import React from "react";
import Checkbox from "Components/common/Checkbox/Checkbox";

class FieldHours extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            details: [
                { id: "name", label: "Task Name", disabled: true }, 
                { id: "assignee", label: "Assignee" }, 
                { id: "dependency", label: "Dependency" }, 
                { id: "subtasks", label: "Subtasks", disabled: true }, 
                { id: "reviewer", label: "Reviewer" }, 
                { id: "description", label: "Description" },
                { id: "recurrence", label: "Recurrence", disabled: true }, 
                { id: "approver", label: "Approver" },
                { id: "applicablePeriod", label: "Applicable Period" }
            ]
        }
    }

    onUpdateField(e) {
        const isChecked = this.props.value.indexOf( e ) > -1;

        if( this.props.onChange ) {
            this.props.onChange({ target: { id: "details", value: !isChecked ? [...this.props.value, e] : this.props.value.filter( d => d !== e ) } });
        }
    }

    render() {
        return (
            <div class="details-checkbox">
                { this.state.details.map( d => (
                    <div class={`form-container ${ d.disabled ? "disabled" : "" }`}>
                        <Checkbox checked={ !d.disabled ? this.props.value.indexOf( d.id ) > -1 : true } onChange={ () => this.onUpdateField(d.id) } />
                        <label>{ d.label }</label>
                    </div>
                ) )}
            </div>
        )
    }
}

export default FieldHours;